import {Route, Routes, useNavigate, Navigate } from "react-router-dom";

import {hostRoutes, IRoute, publicRoutes, publicRoutesHospi, studentRoutes,} from "../routes";
import {useContextHospi} from "../context/ContextHospi";
import {initAmplify} from "utils/utilAmplify";
import {MainFlow} from "../components/containers";
import {ContextHostProvider} from "context/ContextHost";
import {Wrapper} from "../components/GAnalyticsWrapper";
import {useAnalytics} from "../components/GAnalytics";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router";
import {Header} from "./Header";
import {Footer} from "./Footer";
import {CookieBanner} from "./cookieBanner";

initAmplify();

export const HospiRouter = () => {
    const {userStatus, loading, userLoading, currentUserID} = useContextHospi();
    const {initialized} = useAnalytics();
    const {i18n} = useTranslation('home');
    const location = useLocation()
    const navigate = useNavigate()
    const mainRef = useRef<HTMLElement>(null)
    const addRef = useRef<any>(null)

    const [isIOS, setIsIOS] = useState<boolean>(true)
    const [isSafari, setIsSafari] = useState<any>(false)
    const [isAuth, setIsAuth] = useState<boolean | string>('')

    useEffect(() => {
        //@ts-ignore
        const isSafari = !!navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)

        const updateOrientation = function () {
            setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) && window.orientation === 0)
        }
        setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) && window.orientation === 0)
        setIsSafari(isSafari)
        window.addEventListener("orientationchange", updateOrientation, false);

    }, [])

    useEffect(() => {
        mainRef.current!.scrollTo(0, 0);
    }, [location.pathname.slice(4)])

  useEffect(() => {
   i18n.on("loaded", () => {
     setTimeout(() => {
             mainRef?.current?.scrollTo(0,0);
           }, 50)
    })
  }, [i18n, mainRef.current])

    useEffect(() => {
        if(!userLoading && currentUserID) {
            setIsAuth(true)
        } else if (!userLoading && !currentUserID) {
            setIsAuth(false)
        }
    }, [userLoading, currentUserID])

    useEffect(() => {
        i18n.on("loaded", (res) => {
                setTimeout(() => {
                    mainRef.current!.scrollTo(0, 0);
                }, 50)
        })
    }, [i18n, mainRef.current])

    useEffect(() => {
        if (location.pathname.slice(4) === 'student' && userStatus === 'host') {
            navigate(`/${i18n.language}/host`)
        } else if (location.pathname.slice(4) === 'host' && userStatus === 'student') {
            navigate(`/${i18n.language}/student`)
        }
    }, [userStatus, location.pathname, i18n.language])

    return (
        <MainFlow isIOS={isIOS} isSafari={isSafari} marginAuto={location.pathname.includes('edit-first')}>
            <Header/>
            <div ref={addRef}/>
            <main id="hospi-main" ref={mainRef}>
                <ContextHostProvider>
                    <Wrapper initialized={initialized}>
                        <Routes>
                            <>
                                {[...publicRoutes, ...publicRoutesHospi].map(
                                    ({path, component}: IRoute) => (
                                        <Route path={path} element={component} key={path}/>
                                    )
                                )}
                                {userStatus === "student" &&
                                studentRoutes.map(({path, component}: IRoute) => (
                                    <Route path={path} element={component} key={path}/>
                                ))}
                                {userStatus === "host" && (
                                    hostRoutes.map(({path, component}: IRoute) => (
                                        <Route path={path} element={component} key={path}/>
                                    ))
                                )}
                                {!['room-edit', 'room-info'].includes(location.pathname.split('/')[2]) &&
                                ![...publicRoutes, ...publicRoutesHospi, ...studentRoutes, ...hostRoutes].map(({path}) => path.replace(':lng', i18n.language)).includes(location.pathname) &&
                                <Navigate to={`/${i18n.language}/`}/>}
                                {(typeof isAuth === 'boolean' && !isAuth) && <Route
                                    path="*"
                                    element={<Navigate to="/" replace />}
                                />}
                            </>
                        </Routes>
                    </Wrapper>
                </ContextHostProvider>
                <CookieBanner/>
                <Footer/>
            </main>
        </MainFlow>
    );
};
